import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

export const Step14_Filhos: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.children) newErrors.children = 'Campo obrigatório';
    if (data.children === 'yes' && !data.childrenCount) {
      newErrors.childrenCount = 'Número de filhos é obrigatório';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ children: data.children as 'yes' | 'no', childrenCount: data.childrenCount });
  };

  const handleFieldChange = (fieldName: keyof FormData, value: string | number) => {
    updateField(fieldName, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="Você tem filhos?">
      <div className="space-y-6">
        <div>
          <ChoiceButtons
            options={[
              { label: 'Sim', value: 'yes' },
              { label: 'Não', value: 'no' },
            ]}
            selected={data.children || ''}
            onSelect={(value) => handleFieldChange('children', value)}
          />
          {errors.children && (
            <p className="text-red-600 text-sm mt-2">{errors.children}</p>
          )}
        </div>

        {data.children === 'yes' && (
          
          <FormFieldGroup
            label="Quantos filhos você tem?"
            required
            error={errors.childrenCount}
          >
            <input
              type="number"
              placeholder="Ex: 2"
              value={data.childrenCount?.toString() || ''}
              onChange={(e) => handleFieldChange('childrenCount', parseInt(e.target.value) || '')}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"

            />
          </FormFieldGroup>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step14_Filhos;
